import { createSelector } from 'reselect'
import {
  FinancialDto,
  SalesPersonDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { ProjectState } from './ProjectTypes'

function MaterialsSelector(state: RootAppState) {
  return state.materials
}

function ProjectDataSelector(state: RootAppState) {
  return state.project.activeProject
}

function GetProjectFilters(state: RootAppState) {
  return state.project.filters
}

function GetSalesRepr(state: RootAppState) {
  return state.project.activeProject?.salesPerson
}

// function IssuesFilterSelector(state: RootAppState) {
//   return (state.newProjectReducer.filters.find(x => x.type === 'IssuesFilter') as IssuesFilter)
// }

// function WorkingStepsFilterSelector(state: RootAppState) {
//   return (state.newProjectReducer.filters.find(x => x.type === 'WorkingStepsFilter') as WorkingStepFilter)
// }

// function MaterialsFilterSelector(state: RootAppState) {
//   return (state.newProjectReducer.filters.find(x => x.type === 'MaterialKeywordsFilter') as MaterialKeywordsFilter)
// }

type projectStateSelector = {
  PasteMaterialSelectorFromClipboardIsDisabled: (state: RootAppState) => boolean
  ProjectIdSelector: (state: RootAppState) => string
  IssuesCountSelector: (state: RootAppState) => number
  IssuesFilterSelector: (
    state: RootAppState
  ) => ProjectState['filters']['byIssues']
  MaterialFilterSelector: (
    state: RootAppState
  ) => ProjectState['filters']['byMaterialKeywords']
  WorkingStepsFilter: (
    state: RootAppState
  ) => ProjectState['filters']['byWorkingStep']
  SalesRepresentant: (state: RootAppState) => SalesPersonDto
}

export const ProjectStateSelectors: projectStateSelector = {
  PasteMaterialSelectorFromClipboardIsDisabled: createSelector(
    MaterialsSelector,
    (materialSelector) =>
      materialSelector.materialSelectorClipboard === undefined
  ),
  ProjectIdSelector: createSelector(
    ProjectDataSelector,
    (activeProject) => activeProject?.id
  ),
  IssuesFilterSelector: createSelector(
    GetProjectFilters,
    (issues) => issues.byIssues
  ),
  IssuesCountSelector: createSelector(
    GetProjectFilters,
    (issues) => issues.byIssues?.filter?.availableFilters?.length
  ),
  MaterialFilterSelector: createSelector(
    GetProjectFilters,
    (filters) => filters.byMaterialKeywords
  ),
  WorkingStepsFilter: createSelector(
    GetProjectFilters,
    (filters) => filters.byWorkingStep
  ),
  SalesRepresentant: createSelector(GetSalesRepr, (x) => x),
}

export const bomItemFinancialSelector =
  (bomItemId: string) =>
  (state: RootAppState): FinancialDto | null => {
    if (!state.project.activeProject?.id) {
      return null
    }

    if (bomItemId === state.project?.activeProject?.id) {
      return state.project.activeProject.financial
    }

    const bomItem =
      state.project.flatView[bomItemId] || state.project.treeView[bomItemId]

    if (!bomItem) {
      return null
    }

    switch (bomItem?.type) {
      case 'Assembly': {
        return bomItem.financial
      }
      case 'AssemblyHeader': {
        return bomItem.assembly.financial
      }
      case 'MaterialHeader': {
        return null
      }
      case 'Row': {
        return bomItem.financial
      }
      default: {
        return bomItem['financial']
      }
    }
  }
